import axios from "fetch-api/fetch-api";
import { IActionResponse } from "../interfaces/base-response";

export function updateDeliveryMethodApi(deliveryMethod: string) {
  return axios.post<IActionResponse>("/update-delivery-method-v3", { deliveryMethod });
}
